import type {
  CreateLocationRequest,
  ListLocationsResponse,
  LocationResponse,
  UpdateLocationRequest,
} from '@jq4race/shared';

import { request } from './client.js';

export async function listLocations(params?: {
  status?: 'active' | 'inactive';
}): Promise<ListLocationsResponse> {
  const qs = params?.status ? `?status=${encodeURIComponent(params.status)}` : '';
  return request<ListLocationsResponse>(`/admin/locations${qs}`, { method: 'GET' });
}

export async function createLocation(input: CreateLocationRequest): Promise<LocationResponse> {
  return request<LocationResponse>('/admin/locations', { method: 'POST', body: input });
}

export async function getLocation(id: string): Promise<LocationResponse> {
  return request<LocationResponse>(`/admin/locations/${encodeURIComponent(id)}`, { method: 'GET' });
}

export async function updateLocation(
  id: string,
  input: UpdateLocationRequest,
): Promise<LocationResponse> {
  return request<LocationResponse>(`/admin/locations/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: input,
  });
}

export async function deactivateLocation(id: string): Promise<LocationResponse> {
  return request<LocationResponse>(`/admin/locations/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST',
  });
}

export async function activateLocation(id: string): Promise<LocationResponse> {
  return request<LocationResponse>(`/admin/locations/${encodeURIComponent(id)}/activate`, {
    method: 'POST',
  });
}

// ── Super-admin cross-org location lookup — qr-generator org/location picker ──

/**
 * GET /super-admin/organizations/:orgId/locations — lists the active
 * locations of an arbitrary organization. super_admin-only; used by the
 * qr-generator select page's dependent location picker once an org is
 * chosen (the tenant-scoped `listLocations()` above only sees the caller's
 * own org, which a super_admin JWT doesn't have).
 */
export async function listOrganizationLocationsAsSuperAdmin(
  orgId: string,
): Promise<ListLocationsResponse> {
  return request<ListLocationsResponse>(
    `/super-admin/organizations/${encodeURIComponent(orgId)}/locations`,
    { method: 'GET' },
  );
}
